import React from 'react';
import { NavLink } from 'react-router-dom';

const TeesItem = ({ tee }) => {
  const { heading, price } = tee;
  return (
    <div>
      <div className='img-tees'></div>
      <NavLink to='/tees/product'>
        <p className='text-light TeesItem_heading m-0'>{heading}</p>
      </NavLink>

      <p className='text-light TeesItem_para'>₹ {price}</p>
    </div>
  );
};

export default TeesItem;
